<div class="modal-header">
  <h5 class="modal-title mb-0" id="sb-text-condition-title">{{ title }}</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
</div>

<div class="modal-body sb-text-condition" role="group" aria-labelledby="sb-text-condition-title">
  @for (item of cases; track trackByUid(caseIndex, item); let caseIndex = $index) {
  <section
    class="sb-text-condition__case"
    [attr.aria-label]="cases.length > 1 ? 'Case ' + (caseIndex + 1) : null">
    <div class="sb-text-condition__sentence">
      <span>{{ caseIndex === 0 ? showWord : 'Otherwise, ' + (showWord | lowercase) }} this text when</span>
      @if (item.rules.length > 1) {
        <select
          class="form-control form-control-sm sb-text-condition__match"
          aria-label="How many rules must be true"
          [ngModel]="item.match"
          (ngModelChange)="item.match = $event">
          @for (mode of matchItems; track mode) {
          <option [ngValue]="mode.id">{{ mode.name }}</option>
          }
        </select>
        <span>of these are true:</span>
      } @else {
      <span class="sb-text-condition__colon">:</span>
      }
      @if (caseIndex > 0) {
      <app-sb-button
        class="sb-text-condition__case-remove"
        variant="link"
        size="sm"
        icon="fa fa-trash"
        [iconOnly]="true"
        label="Remove this case"
        [ariaLabel]="'Remove case ' + (caseIndex + 1)"
        (clicked)="removeCase(item)">
      </app-sb-button>
      }
    </div>

    <ul class="sb-text-condition__rules">
      @for (row of item.rules; track trackByUid(ruleIndex, row); let ruleIndex = $index) {
      <li
        class="sb-text-condition__rule"
        [attr.data-rule]="row.uid">
        <div class="sb-text-condition__rule-main">
          <app-sb-input-select
            class="sb-text-condition__variable"
            label="Variable"
            [items]="row.variableItems"
            [clearable]="false"
            [ngModel]="row.variable || null"
            (ngModelChange)="onVariableChange(row, $event)">
          </app-sb-input-select>
          <app-sb-input-select
            class="sb-text-condition__operator"
            label="Comparison"
            [items]="row.operatorItems"
            [clearable]="false"
            [autocomplete]="false"
            [disabled]="!row.variable"
            [ngModel]="row.operator || null"
            (ngModelChange)="onOperatorChange(row, $event)">
          </app-sb-input-select>
          @if (needsValue(row)) {
          <div class="sb-text-condition__value">
            @if (hasOptions(row)) {
            <app-sb-input-select
              label="Value"
              [items]="row.optionItems"
              [clearable]="false"
              [ngModel]="row.value || null"
              (ngModelChange)="onValueChange(row, $event)">
            </app-sb-input-select>
            }
            @if (!hasOptions(row) && isNumeric(row)) {
            <app-sb-input-number
              label="Number"
              [ngModel]="row.value"
              (ngModelChange)="onValueChange(row, $event)"
              (keydown)="onValueKeydown($event, row)">
            </app-sb-input-number>
            }
            @if (!hasOptions(row) && !isNumeric(row)) {
            <app-sb-input-text
              label="Value"
              [ngModel]="row.value"
              (ngModelChange)="onValueChange(row, $event)"
              (keydown)="onValueKeydown($event, row)">
            </app-sb-input-text>
            }
          </div>
          } @else {
          <div class="sb-text-condition__value sb-text-condition__value--none"></div>
          }
          <app-sb-button
            class="sb-text-condition__rule-remove"
            variant="link"
            size="sm"
            icon="fa fa-times"
            [iconOnly]="true"
            label="Remove rule"
            [ariaLabel]="'Remove rule ' + (ruleIndex + 1)"
            (clicked)="removeRule(item, row)">
          </app-sb-button>
        </div>
        @if (hintOf(row)) {
        <div class="sb-field__description sb-text-condition__hint">{{ hintOf(row) }}</div>
        }
        @if (helpOf(row)) {
        <div class="sb-field__description sb-text-condition__hint">{{ helpOf(row) }}</div>
        }
        @if (!shownProblem(row) && warningOf(row)) {
        <div class="sb-text-condition__message sb-text-condition__message--warning">
          {{ warningOf(row) }}
        </div>
        }
        @if (shownProblem(row)) {
        <div class="bar error-brd sb-field__error">
          <div class="invalid-text" role="alert">{{ shownProblem(row) }}</div>
        </div>
        }
      </li>
      }
    </ul>

    <app-sb-button
      class="sb-text-condition__add"
      variant="outline-secondary"
      size="sm"
      icon="fa fa-plus"
      label="Add rule"
      [disabled]="item.rules.length >= maxRules"
      (clicked)="addRule(item)">
    </app-sb-button>

    <app-sb-input-textarea
      class="sb-text-condition__text"
      [label]="thenLabel"
      [rows]="2"
      [ngModel]="item.text"
      (ngModelChange)="item.text = $event">
    </app-sb-input-textarea>
  </section>
  }

  <app-sb-button
    class="sb-text-condition__add-case"
    variant="link"
    size="sm"
    icon="fa fa-plus"
    label="Otherwise, if…"
    (clicked)="addCase()">
  </app-sb-button>

  <app-sb-input-textarea
    class="sb-text-condition__otherwise"
    [label]="otherwiseLabel"
    description="Shown when none of the conditions above are true. Leave it empty to show nothing."
    [rows]="2"
    [ngModel]="otherwise"
    (ngModelChange)="otherwise = $event">
  </app-sb-input-textarea>

  @if (preview) {
  <div class="sb-text-condition__preview">
    <div class="sb-field__description">Saved in the field as</div>
    <code>{{ preview }}</code>
  </div>
  }
</div>

<div class="modal-footer sb-text-condition__actions">
  @if (editing) {
  <app-sb-button
    class="sb-text-condition__remove"
    variant="outline-danger"
    label="Remove condition"
    [attr.title]="'Keeps “' + thenLabel + '” and removes the condition around it'"
    (clicked)="remove()">
  </app-sb-button>
  }
  <app-sb-button variant="default" label="Cancel" (clicked)="cancel()"></app-sb-button>
  <app-sb-button
    variant="primary"
    label="Save"
    [disabled]="!canSave"
    [attr.title]="canSave ? null : problems[0]"
    (clicked)="save()">
  </app-sb-button>
</div>
